import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-existing-customer-list',
  templateUrl: './existing-customer-list.component.html',
  styleUrls: ['./existing-customer-list.component.css']
})
export class ExistingCustomerListComponent implements OnInit {

  form: any | FormGroup
  modelSubtitle = false
  checked = false
  name = ""
  version = ""
  isActive = false
  data: any =[];
  ECdata: any = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: any = 0
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  isLoading: any = false
  imageUrl:any = ""


actionControls: any = {
  isAdd: false, 
  isView: false, 
  isDelete: false, 
  isModify: false 
}

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {


  let href:any = window.location.href;
  let messages = href.split('/') 
  let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action
    this.cid = sessionStorage.getItem('cid')
    this.getAllEC();
    this.form = this.fb.group({
      existingCustomerInfoId: [''],
    })  
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllEC();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllEC();
  }

  getAllEC(){
    this.isLoading = true

    this.generic_service.getAllExistingCustomerInfo().subscribe(
      (response:any)=>{
        this.ECdata = response.response;
        this.count = response.response.length;
        console.log(response)
        this.isLoading = false

      }
    )
  }

  getECbyId(id:any){
    this.generic_service.getExistingCustomerById(id).subscribe(
      (res:any)=>{
        this.data = [];
        this.imageUrl = ""
        console.log(res);
        this.data.push(res.response);

        // this.form.setValue(
        //   {
        //     existingCustomerInfoId: res.response.existingCustomerInfoId,
        //     userId: ['']
        //   }
        // );
      }
    )
  }

  imageUrlSelect(url:any){
    this.imageUrl = url
  }

  closeImage(){
    this.imageUrl = ""
  }

}
